module.exports = {"title":"Forms","__content":"<h2 id=\"forms\">Forms</h2>\n<p>How users get data into your services</p>\n<h3 id=\"essentials\">Essentials</h3>\n<ul>\n<li>Always wrap with a <code>&lt;form&gt;</code> element</li>\n<li>Vertically align your fields for better readability/scanning</li>\n<li>Have <code>label</code> for every <code>input</code></li>\n</ul>\n<h4 id=\"more-info\">More Info</h4>\n<p>See subsections of the forms section for more detail</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./~/markdown-with-front-matter-loader?passoverHTML=true!./src/documentation/Forms/Index.md
// module id = 209
// module chunks = 0